import React, {useEffect, useState} from "react";
import {Box, Button, Dialog, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

const CONFIRMED_KEY = "mytales-age-confirmed";

const useStyles = makeStyles((theme) => ({
    paper: {
        width: "calc(100% - 32px)",
        maxWidth: 420,
        margin: theme.spacing(2),
        padding: theme.spacing(5, 4, 4),
        textAlign: "center",
        borderRadius: 24,
        background: "radial-gradient(420px 220px at 50% 0%, rgba(236, 122, 150, 0.16), transparent 70%), #21161F",
        [theme.breakpoints.down("xs")]: {
            padding: theme.spacing(4, 3, 3),
        },
    },
    badge: {
        width: 64,
        height: 64,
        margin: "0 auto",
        marginBottom: theme.spacing(2.5),
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid rgba(236, 122, 150, 0.5)",
        color: theme.palette.primary.light,
        fontWeight: 700,
        fontSize: "1.15rem",
        letterSpacing: "-0.02em",
    },
    title: {
        fontSize: "1.75rem",
        marginBottom: theme.spacing(1.5),
    },
    text: {
        color: theme.palette.text.secondary,
        lineHeight: 1.6,
        marginBottom: theme.spacing(4),
    },
    actions: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
    },
    confirm: {
        "&.Mui-focusVisible": {
            boxShadow: "0 0 0 3px rgba(236, 122, 150, 0.35)",
        },
    },
    leave: {
        color: theme.palette.text.secondary,
    },
}));

// Asks once per browser whether the visitor is 18 or older; drawn after load, so the page itself stays in the HTML
export default function AgeGate() {
    const classes = useStyles();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        try {
            setOpen(window.localStorage.getItem(CONFIRMED_KEY) !== "yes");
        } catch (error) {
            setOpen(true);
        }
    }, []);

    const confirm = () => {
        try {
            window.localStorage.setItem(CONFIRMED_KEY, "yes");
        } catch (error) {
            // storage blocked: the question comes back next visit
        }
        setOpen(false);
    };

    return (
        <Dialog open={open} disableBackdropClick disableEscapeKeyDown aria-labelledby="age-gate-title"
                classes={{paper: classes.paper}}>
            <Box className={classes.badge} aria-hidden="true">18+</Box>
            <Typography variant="h4" component="h2" id="age-gate-title" className={classes.title}>
                MyTales is for adults
            </Typography>
            <Typography className={classes.text}>
                MyTales has interactive stories with explicit sexual content. You must be 18 or older to continue.
            </Typography>
            <Box className={classes.actions}>
                <Button onClick={confirm} color="primary" variant="contained" size="large" fullWidth autoFocus
                        disableFocusRipple className={classes.confirm}>I'm 18 or older</Button>
                <Button onClick={() => window.location.assign("https://www.google.com")} fullWidth
                        className={classes.leave}>Leave</Button>
            </Box>
        </Dialog>
    );
}
